import Vue from 'vue'
export const vueBus = new Vue()



// WEBPACK FOOTER //
// ./src/assets/js/common/vueBus.js